import React from 'react';
import { About } from '../components/About';
export function QuienesSomos() {
  return <div className="pt-24 md:pt-28" data-id="element-351">
      <About data-id="element-352" />
    </div>;
}